import { createSlice } from '@reduxjs/toolkit';

// utils
import getActionChatInfo from 'src/actions/chats/getActionChatInfo';
import getActionTransferirChat from 'src/actions/chats/getActionTransferirChat';
import getListaFunilByChatId from 'src/actions/chats/getListaFunilByChatId';

// actions whatsapp

import actionGetChatMeta from 'src/actions/chats/meta/actionGetChatMeta';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import v2_actionListaByStatus from 'src/actions/v2/services/chats/v2_actionListaByStatus';

import getActionChatsPendentesMarketplace from '../../actions/chats/getActionChatsPendentesMarketplace';
import getActionListaChatsByStatus from "../../actions/chats/getActionListaChatsByStatus"
import getActionAllMessagesWhatsapp from '../../actions/chats/whatsapp/getActionAllMessagesWhatsapp';
import actionGetMessages from '../../actions/chats/whatsapp/getMessagesNew';
import axios from '../../utils/axios';
import getActionPesquisarChat from 'src/actions/chats/getActionPesquisarChat';
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import v2_actionCountChats from 'src/actions/v2/chats/v2_actionCountChats';
import v1_actionBuscarMensagensWhatsapp from 'src/actions/v1/whatsapp/v1_actionBuscarMensagensWhatsapp';
import Worker from "../../actions/idb/workers/app.worker.worker?worker";
import v1_actionBuscarMensagensArquivos from 'src/actions/v1/whatsapp/v1_actionBuscarMensagensArquivos';
import v2_actionGetSentimentAnalysis from 'src/actions/v2/ai/v2_actionGetSentimentAnalysis';
import v2_actionBuscarMensagens from 'src/actions/v2/whatsapp/v2_actionBuscarMensagens';
import v2_actionBloquearChat from 'src/actions/v2/chats/v2_actionBloquearChat';
import v2_actionDesbloquearChat from 'src/actions/v2/chats/v2_actionDesbloquearChat';
import v2_actionToggleBotSilence from 'src/actions/v2/chats/v2_actionToggleBotSilence';
import v2_actionListGroups from 'src/actions/v2/groups/v2_actionListGroups';
import v2_actionCreateGroup from 'src/actions/v2/groups/v2_actionCreateGroup';
import v2_actionGetGroup from 'src/actions/v2/groups/v2_actionGetGroup';
import v2_actionUpdateGroup from 'src/actions/v2/groups/v2_actionUpdateGroup';
import v2_actionAddParticipants from 'src/actions/v2/groups/v2_actionAddParticipants';
import v2_actionRemoveParticipant from 'src/actions/v2/groups/v2_actionRemoveParticipant';
import v2_actionPromoteAdmin from 'src/actions/v2/groups/v2_actionPromoteAdmin';
import v2_actionDemoteAdmin from 'src/actions/v2/groups/v2_actionDemoteAdmin';
import v2_actionLeaveGroup from 'src/actions/v2/groups/v2_actionLeaveGroup';
import v2_actionGetInviteLink from 'src/actions/v2/groups/v2_actionGetInviteLink';
import v2_actionRevokeInviteLink from 'src/actions/v2/groups/v2_actionRevokeInviteLink';
import v2_actionGroupCostPreview from 'src/actions/v2/groups/v2_actionGroupCostPreview';
import v2_actionSendGroupMessage from 'src/actions/v2/groups/v2_actionSendGroupMessage';
import v2_actionListGroupEvents from 'src/actions/v2/groups/v2_actionListGroupEvents';
const wbWorker = new Worker();

const initialState = {
  isLoading: false,
  chats_atendendo_loading: false,
  loadingChat: false,
  error: false,
  contacts: { byId: {}, allIds: [] },
  conversations: { byId: {}, allIds: [] },
  activeConversationId: null,
  participants: [],
  recipients: [],
  chatsAtendimento: [],
  chatsPendente: [],
  chatsFinalizado: [],
  chatsPendentesMarketplace: [],
  chatsGeral: [],
  countsListaChats: {
    count_finalizado: 0,
    count_pendente: 0,
    count_atendendo: 0,
    count_geral: 0,
  },
  loadingListaChatsAtendendo: false,
  loadingListaChatsPendente: false,
  loadingListaChatsGeral: false,
  loadingListaChatsFinalizados: false,
  chatInfo: null,
  dialogRespostas: [],
  listaRespostas: [],
  listaFunil: [],
  listaTags: [],
  selectedMessage: null,
  sheet: null,
  chatIsOnline: null,
  verificaChatOnline: null,
  numeroClienteActive: false,
  dialogRespostasRapidas: false,
  pesquisasChat: [],
  drawerPesquisasChat: false,
  showLoadAllMessages: true,
  audioPlayerRedux: null,
  audioRedux: null,
  playingRedux: false,
  playbackRateRedux: 1,
  audioMessageId: null,
  loadingPesquisarChat: false,
  chatsAnalysis: [],
  newMessagesCliente: [],
  mensagensEnviar: [],
  mensagens: [],
  mensagensArquivos: [],
  mensagensMeta: [],
  chatsGrupos: [],
  loadingListaChatsGrupos: false,
  groupCostPreview: null,
  groupEvents: []
};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startLoadingAtendendo(state) {
      state.loadingListaChatsAtendendo = true;
    },
    startLoadingGeral(state) {
      state.loadingListaChatsGeral = true;
    },
    startLoadingPendente(state) {
      state.loadingListaChatsPendente = true;
    },
    startLoadingFinalizados(state) {
      state.loadingListaChatsFinalizados = true;
    },
    stopLoadingAtendendo(state) {
      state.loadingListaChatsAtendendo = false;
    },
    stopLoadingGeral(state) {
      state.loadingListaChatsGeral = false;
    },
    stopLoadingPendente(state) {
      state.loadingListaChatsPendente = false;
    },
    stopLoadingFinalizados(state) {
      state.loadingListaChatsFinalizados = false;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    setShowLoadAllMessagesWhatsapp(state, action) {
      state.showLoadAllMessages = action.payload;
    },

    startLoadingChat(state) {
      state.loadingChat = true;
    },
    startLoadingPesquisarChat(state) {
      state.loadingPesquisarChat = true;
    },
    stopLoadingPesquisarChat(state) {
      state.loadingPesquisarChat = false;
    },
    stopLoadingChat(state) {
      state.loadingChat = false;
    },

    startLimparChats(state) {
      console.log('startLimparChats');
      state.mensagens = [];
      state.mensagensArquivos = [];
      state.mensagensMeta = [];
      state.mensagensEnviar = [];
      state.newMessagesCliente = [];
    },

    setLimparChatInfo(state) {
      state.chatInfo = null;
      state.mensagens = []
      state.mensagensArquivos = []
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.loadingChat = false;
      state.error = action.payload;
    },



    // GET PARTICIPANTS
    getParticipantsSuccess(state, action) {
      const participants = action.payload;
      state.participants = participants;
    },

    // RESET ACTIVE CONVERSATION
    resetActiveConversation(state) {
      state.activeConversationId = null;
    },

    addRecipients(state, action) {
      const recipients = action.payload;
      state.recipients = recipients;
    },


    setCountsListaChats(state, action) {
      state.countsListaChats = action.payload;
    },


    setDialogRespostas(state, action) {
      state.dialogRespostasRapidas = action.payload;
    },

    // BUSCAR CHATS EM ATENDIMENTO
    getMessagesMetaSuccess(state, action) {

      state.mensagensMeta = action.payload;
      state.loadingChat = false;
    },

    setMetaMessages(state, action) {
      state.mensagensMeta.push(action.payload);
    },

    // BUSCAR CHATS EM ATENDIMENTO
    getMessagesWhatsappSuccess(state, action) {
      state.isLoading = false;
      state.mensagens = action.payload;
    },

    // BUSCAR TODAS MENSAGENS WHATSAPP
    getAllMessagesWhatsappSuccess(state, action) {
      state.isLoading = false;
      state.mensagens = action.payload;
    },

    // CARREGAR MENSAGENS
    getLoadMessagesWhatsappSuccess(state, action) {
      state.mensagens = action.payload;
      state.loadingChat = false;
    },

    setMessagesWhatsapp(state, action) {
      state.mensagens = action.payload;
    },

    getLoadMessagesArquivosWhatsappSuccess(state, action) {
      state.mensagensArquivos = action.payload;
    },

    // GRUPOS WhatsApp
    startLoadingChatsGrupos(state) {
      state.loadingListaChatsGrupos = true;
    },
    stopLoadingChatsGrupos(state) {
      state.loadingListaChatsGrupos = false;
    },
    setChatsGrupos(state, action) {
      state.chatsGrupos = action.payload || [];
      state.loadingListaChatsGrupos = false;
    },
    upsertChatGrupo(state, action) {
      const incoming = action.payload;
      if (!incoming || !incoming._id) return;
      const idx = state.chatsGrupos.findIndex(c => c._id === incoming._id);
      if (idx >= 0) {
        state.chatsGrupos[idx] = { ...state.chatsGrupos[idx], ...incoming };
      } else {
        state.chatsGrupos.unshift(incoming);
      }
    },
    removeChatGrupo(state, action) {
      const id = action.payload;
      state.chatsGrupos = state.chatsGrupos.filter(c => c._id !== id);
    },
    updateChatGrupoFromSocket(state, action) {
      const scope = action.payload;
      if (!scope || !scope.chat_id) return;
      const idx = state.chatsGrupos.findIndex(c => c._id === scope.chat_id);
      if (idx < 0) return;
      const message = scope.message;
      if (message) {
        state.chatsGrupos[idx].lastMessage = message.body;
        state.chatsGrupos[idx].lastMessageWpp = {
          type: message.type,
          message: message.body,
          fromMe: !!message.fromMe,
          timestamp: new Date((message.timestamp || Date.now() / 1000) * 1000).toISOString(),
          ack: message.ack,
          id: message.id,
          groupSenderName: message.groupSenderName,
          groupSenderWaId: message.groupSenderWaId
        };
        state.chatsGrupos[idx].dataUltimaMensagem = new Date().toISOString();
        if (!message.fromMe) state.chatsGrupos[idx].novaMensagem = 'sim';
      }
      // mover topo
      const updated = state.chatsGrupos.splice(idx, 1)[0];
      state.chatsGrupos.unshift(updated);
    },
    setGroupCostPreview(state, action) {
      state.groupCostPreview = action.payload;
    },
    clearGroupCostPreview(state) {
      state.groupCostPreview = null;
    },
    setGroupEvents(state, action) {
      state.groupEvents = action.payload || [];
    },

    // BUSCAR CHATS EM ATENDIMENTO
    getChatsAtendimentoSuccess(state, action) {
      state.isLoading = false;
      state.loadingListaChatsAtendendo = false;
      state.chatsAtendimento = action.payload;
    },

    // BUSCAR CHATS PENDENTES
    getChatsPendenteSuccess(state, action) {
      state.chatsPendente = action.payload;
      state.loadingListaChatsPendente = false;
    },


    // BUSCAR CHATS PENDENTES
    getChatsFinalizadosSuccess(state, action) {
      state.chatsFinalizado = action.payload;
      state.loadingListaChatsFinalizados = false;
    },

    // BUSCAR CHATS GERAL
    getChatsGeralSuccess(state, action) {
      state.isLoading = false;
      state.chatsGeral = action.payload;
      state.loadingListaChatsGeral = false;
    },

    // BUSCAR INFORMAÇÕES DE CHAT
    getChatsInfoSuccess(state, action) {
      state.isLoading = false;
      state.chatInfo = action.payload;
    },

    // BUSCAR INFORMAÇÕES DE CHAT by CHAT ID
    getChatsInfoByChatIdSuccess(state, action) {
      state.chatInfo = action.payload;
      state.isLoading = false;
    },



    // TRANSFERIR CHAT
    getTransferirChatSuccess(state) {
      state.isLoading = false;
    },

    // setSelectedMessage
    setSelectedMessage(state, action) {

      state.selectedMessage = action.payload.message;
      state.isLoading = false;
    },

    setChatInfo(state, action) {
      state.chatInfo = action.payload;
    },
    setMessagesArquivosWhatsapp(state, action) {
      state.mensagensArquivos = action.payload;
    },


    setNumeroClienteActive(state, action) {
      state.numeroClienteActive = action.payload;
    },

    setVerificaChatOnline(state, action) {
      state.verificaChatOnline = action.payload;
    },

    setChatIsOnline(state, action) {
      state.chatIsOnline = action.payload;
    },

    setMensagensEnviar(state, action) {
      // Verificar se a mensagem já existe para evitar duplicatas
      const existingMsg = state.mensagensEnviar.find(msg => msg.id === action.payload.id);
      if (!existingMsg) {
        state.mensagensEnviar.push(action.payload);
      }
    },
    updateMensagensEnviar(state, action) {
      state.mensagensEnviar = action.payload;
    },
    resetMensagensEnviar(state) {
      state.mensagensEnviar = []
    },


    // LISTA FUNIL
    getListaFunilSuccess(state, action) {
      state.listaFunil = action.payload;
      state.isLoading = false;
    },

    // LISTA TAGS
    getListaTagsSuccess(state, action) {
      state.listaTags = action.payload;
      state.isLoading = false;
    },

    limparProcurarChats(state) {
      state.mensagens = []
      state.mensagensArquivos = []
    },

    limparChats(state) {
      state.mensagens = []
      state.mensagensArquivos = []
    },
    getPesquisarChatsSuccess(state, action) {
      state.pesquisasChat = action.payload
    },
    setDrawerPesquisas(state, action) {
      state.drawerPesquisasChat = action.payload
    },

    // INSERIR MENSAGENS AO CHAT
    setMessageSuccess(state, action) {
      const novaMensgaem = action.payload;
      state.mensagens.push(novaMensgaem);
      if (['image', 'audio', 'video', 'document'].includes(novaMensgaem.type)) {
        state.mensagensArquivos.push(novaMensgaem);
      }
      // state.mensagens = action.payload;
    },
    setPushMensagemMeta(state, action) {
      const novaMensgaem = action.payload;
      state.mensagensMeta.push(novaMensgaem);
    },
    removeChatFromList(state, action) {
      const data = action.payload;
      switch (data.status) {
        case "Atendendo": {
          const initialLength = state.chatsAtendimento.length;
          state.chatsAtendimento = state.chatsAtendimento.filter((chat) => chat._id !== data.chatId);
          // Decrementa apenas se algo foi realmente removido
          if (state.chatsAtendimento.length < initialLength) {
            state.countsListaChats.count_atendendo -= 1;
          }
          break;
        }
        case "Pendente": {
          const initialLength = state.chatsPendente.length;
          state.chatsPendente = state.chatsPendente.filter((chat) => chat._id !== data.chatId);
          if (state.chatsPendente.length < initialLength) {
            state.countsListaChats.count_pendente -= 1;
          }
          break;
        }
        case "Geral": {
          const initialLength = state.chatsGeral.length;
          state.chatsGeral = state.chatsGeral.filter((chat) => chat._id !== data.chatId);
          if (state.chatsGeral.length < initialLength) {
            state.countsListaChats.count_geral -= 1;
          }
          break;
        }
        case "Finalizado": {
          const initialLength = state.chatsFinalizado.length;
          state.chatsFinalizado = state.chatsFinalizado.filter((chat) => chat._id !== data.chatId);
          if (state.chatsFinalizado.length < initialLength) {
            state.countsListaChats.count_finalizado -= 1;
          }
          break;
        }
        default:
          break;
      }
    },
    setPushChatList(state, action) {
      const data = action.payload;

      switch (data.status) {
        case "Atendendo": {
          // Verifica se há novos itens sendo adicionados
          const initialLength = state.chatsAtendimento.length;
          state.chatsAtendimento = [...state.chatsAtendimento, ...data.payload];
          if (state.chatsAtendimento.length > initialLength) {
            state.countsListaChats.count_atendendo += (state.chatsAtendimento.length - initialLength);
          }
          break;
        }
        case "Pendente": {
          const initialLength = state.chatsPendente.length;
          state.chatsPendente = [...state.chatsPendente, ...data.payload];
          if (state.chatsPendente.length > initialLength) {
            state.countsListaChats.count_pendente += (state.chatsPendente.length - initialLength);
          }
          break;
        }
        case "Geral": {
          const initialLength = state.chatsGeral.length;
          state.chatsGeral = [...state.chatsGeral, ...data.payload];
          if (state.chatsGeral.length > initialLength) {
            state.countsListaChats.count_geral += (state.chatsGeral.length - initialLength);
          }
          break;
        }
        case "Finalizado": {
          const initialLength = state.chatsFinalizado.length;
          state.chatsFinalizado = [...state.chatsFinalizado, ...data.payload];
          if (state.chatsFinalizado.length > initialLength) {
            state.countsListaChats.count_finalizado += (state.chatsFinalizado.length - initialLength);
          }
          break;
        }
        default:
          break;
      }

    },
    updateChatList(state, action) {
      const { _id, scope } = action.payload; // `_id` para localizar o chat, `updates` para passar os dados modificados[
      const index = state.chatsAtendimento.findIndex(chat => chat._id === _id);
      if (index !== -1) {
        state.chatsAtendimento[index] = {
          ...state.chatsAtendimento[index],
          ...scope, // Mescla as propriedades existentes com as novas
        };
      }
    },
    reorderChatsAtendimento(state) {
      state.chatsAtendimento.sort((a, b) => new Date(b.dataUltimaMensagem) - new Date(a.dataUltimaMensagem));
    },
    removeMsgEnviar(state, action) {
      const data = action.payload;
      console.log('state.mensagensEnviar', state.mensagensEnviar)
      console.log('aqui removeMsgEnviar', data)

      // Se o payload é um array, significa que já foi filtrado no initIO
      if (Array.isArray(data)) {
        state.mensagensEnviar = data;
        console.log('Array filtrado recebido e aplicado')
        return;
      }

      // Garantir que mensagensEnviar seja um array válido
      if (!Array.isArray(state.mensagensEnviar)) {
        state.mensagensEnviar = [];
        return;
      }

      // Verificar se existe uma mensagem com o body correspondente antes de remover
      const mensagemExiste = state.mensagensEnviar.some(item => item.body === data);
      console.log('mensagemExiste para remover:', mensagemExiste)

      if (mensagemExiste) {
        // Filtrar a mensagem pelo body
        state.mensagensEnviar = state.mensagensEnviar.filter((msg) => msg.body !== data);
        console.log('Mensagem removida com sucesso')
      } else {
        console.log('Mensagem não encontrada para remoção')
      }
    },
    setAudioPlayerRedux(state, action) {
      state.audioPlayerRedux = action.payload;
    },
    setAudioRedux(state, action) {
      state.audioRedux = action.payload;
    },
    setPlayingRedux(state, action) {
      state.playingRedux = action.payload;
    },
    setPlaybackRateRedux(state, action) {
      state.playbackRateRedux = action.payload;
    }, setAudioMessageId(state, action) {
      state.audioMessageId = action.payload
    },
    setChatsAnalysis(state, action) {
      console.log('inserindo setChatsAnalysis')
      state.chatsAnalysis.push(action.payload)
    },
    setSuccessSentimentAnalysis(state, action) {
      state.chatsAnalysis = action.payload
    },
    clearSuccessSentimentAnalysis(state, action) {
      state.chatsAnalysis = []
    },
    // NOVAS MENSAGENS DO CLIENTE
    addNewMessageCliente(state, action) {
      state.newMessagesCliente.push(action.payload);
    },
    clearNewMessagesCliente(state, action) {
      state.newMessagesCliente = [];
    },
    clearNewMessagesClienteByChatId(state, action) {
      const chatId = action.payload;
      state.newMessagesCliente = state.newMessagesCliente.filter(msg => msg.chatId !== chatId);
    },

    // ATUALIZAR CAMPO ESPECÍFICO DO CHATINFO
    updateChatInfoField(state, action) {
      const { field, value } = action.payload;
      if (state.chatInfo) {
        console.log('aqui 482', field, value)
        state.chatInfo[field] = value;
      }
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addRecipients,
  onSendMessage,
  resetActiveConversation,
  setDialogRespostas,
  limparProcurarChats,
  setSelectedMessage,
  setVerificaChatOnline,
  startLoading,
  startLoadingAtendendo,
  startLoadingGeral,
  startLoadingPendente,
  startLoadingFinalizados,
  stopLoadingAtendendo,
  stopLoadingGeral,
  stopLoadingPendente,
  stopLoadingFinalizados,
  stopLoading,
  startLoadingChat,
  stopLoadingChat,
  setNumeroClienteActive,
  setChatIsOnline,
  setChatInfo,
  setMetaMessages,
  setDrawerPesquisas,
  setShowLoadAllMessagesWhatsapp,
  setMensagensEnviar,
  updateMensagensEnviar,
  resetMensagensEnviar,
  setPushMensagemMeta,
  removeChatFromList,
  removeMsgEnviar,
  setPushChatList,
  setAudioMessageId,
  setPlaybackRateRedux,
  setPlayingRedux,
  setAudioRedux,
  setAudioPlayerRedux,
  limparChats,
  updateChatList,
  reorderChatsAtendimento,
  setLimparChatInfo,
  setChatsAnalysis,
  setSuccessSentimentAnalysis,
  clearSuccessSentimentAnalysis,
  setMessagesWhatsapp,
  setMessagesArquivosWhatsapp,
  addNewMessageCliente,
  clearNewMessagesCliente,
  clearNewMessagesClienteByChatId,
  startLoadingChatsGrupos,
  stopLoadingChatsGrupos,
  setChatsGrupos,
  upsertChatGrupo,
  removeChatGrupo,
  updateChatGrupoFromSocket,
  setGroupCostPreview,
  clearGroupCostPreview,
  setGroupEvents
} = slice.actions;

// ----------------------------------------------------------------------

// TRANSFERIR CHAT ----------------------------------------------------------------------
export function getTransferirChat(chatId, usuarioId, direcionaSetores, direcionaUsuarios) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let data = {
        id: chatId,
        usuarioId: usuarioId,
        direcionaSetores: direcionaSetores,
        direcionaUsuarios: direcionaUsuarios
      }
      await getActionTransferirChat(data);
      dispatch(slice.actions.getTransferirChatSuccess());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// BUSCAR INFORMAÇÕES DE CHAT ----------------------------------------------------------------------
export function getChatInfoByChatId(chatId, funilId, userId, limparChat) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    if (limparChat) {
      dispatch(slice.actions.setLimparChatInfo());
    }
    try {
      const response = await v2_actionBuscarChatById(chatId, funilId, userId);
      dispatch(slice.actions.getChatsInfoByChatIdSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// BUSCAR INFORMAÇÕES DE CHAT ----------------------------------------------------------------------
export function getChatInfo(clienteId, phone) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionChatInfo(clienteId, phone);
      dispatch(slice.actions.getChatsInfoSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}



// BUSCAR MENSAGENS NO WHATSAPP ----------------------------------------------------------------------
export function getMessagesWhatsapp(phone) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await actionGetMessages(phone);
      if (response.data.response) {
        dispatch(slice.actions.getMessagesWhatsappSuccess(response.data.response));

      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}




// BUSCAR TODAS MENSAGENS NO WHATSAPP ----------------------------------------------------------------------
export function getAllMessagesWhatsapp(phone) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getActionAllMessagesWhatsapp(phone);
      dispatch(slice.actions.getAllMessagesWhatsappSuccess(response.data.response));
    } catch (error) {
      await getMessagesWhatsapp(phone)
      dispatch(slice.actions.hasError(error));
    }
  };
}

// BUSCAR TODAS MENSAGENS NO WHATSAPP ----------------------------------------------------------------------
export function getLoadMessagesInChat(phone) {
  return async (dispatch) => {
    dispatch(slice.actions.startLimparChats());
    dispatch(slice.actions.startLoadingChat());

    try {
      const response = await actionGetMessages(phone);
      dispatch(slice.actions.getLoadMessagesWhatsappSuccess(response.data.response));
    } catch (error) {
      if (error.response && error.response.status === 504) {
        getMessagesWhatsapp(phone);
      }

      dispatch(slice.actions.hasError(error));
    }
  };
}

// BUSCAR TODAS MENSAGENS NO WHATSAPP ----------------------------------------------------------------------
export function getMensagensWhatsapp(sessao, numero) {
  return async (dispatch) => {
    dispatch(slice.actions.startLimparChats());
    dispatch(slice.actions.startLoadingChat());

    try {
      let querys = `?sessao=${sessao}&numero=${numero}&canal=whatsapp&limit=50`
      const response = await v1_actionBuscarMensagensWhatsapp(querys);
      dispatch(slice.actions.stopLoadingChat());
      if (response.data.data) {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess(response.data.data));
      } else {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess([]));
        dispatch(slice.actions.stopLoadingChat());
      }
      dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(null));

    } catch (error) {
      if (error.response && error.response.status === 504) {
        getMessagesWhatsapp(phone);
      }

      dispatch(slice.actions.hasError(error));
    }

  };
}


export function getMessagesMeta(sessao, instagramUserId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      let querys = `?sessao=${sessao}&instagram_user_id=${instagramUserId}&canal=instagram`
      const response = await v1_actionBuscarMensagensWhatsapp(querys);
      dispatch(slice.actions.stopLoadingChat());
      if (response.data.data) {
        dispatch(slice.actions.getMessagesMetaSuccess(response.data.data));
      } else {
        dispatch(slice.actions.getMessagesMetaSuccess([]));
        dispatch(slice.actions.stopLoadingChat());
      }
      dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(null));


    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMensagensWhatsappDb(sessao, numero) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingChat());
    dispatch(slice.actions.startLimparChats());
    try {
      let querys = `?sessao=${sessao}&numero=${numero}&canal=whatsapp&limit=50&chat_source=db&page=1`
      const response = await v2_actionBuscarMensagens(querys);

      dispatch(slice.actions.stopLoadingChat());
      if (response.data.data) {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess(response.data.data));
      } else {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess([]));
      }
      dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(true));
      try {
        const responseArquivos = await v1_actionBuscarMensagensArquivos(querys);
        if (responseArquivos.status === 200) {
          dispatch(slice.actions.getLoadMessagesArquivosWhatsappSuccess(responseArquivos.data.data));
        }
      } catch (error) {
        console.log('Erro ao buscar mensagens arquivos', error)
      }
    } catch (error) {
      if (error.response && error.response.status === 504) {
        getMessagesWhatsapp(phone);
      }
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getMensagensArquivosWhatsappDb(sessao, numero) {
  return async (dispatch) => {

    dispatch(slice.actions.startLoadingChat());
    dispatch(slice.actions.startLimparChats());
    try {
      let querys = `?sessao=${sessao}&numero=${numero}&canal=whatsapp&limit=100&chat_source=db`
      const response = await v1_actionBuscarMensagensArquivos(querys);
      dispatch(slice.actions.stopLoadingChat());
      if (response.data.data) {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess(response.data.data));
      } else {
        dispatch(slice.actions.getLoadMessagesWhatsappSuccess([]));
      }
      dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(true));
    } catch (error) {
      if (error.response && error.response.status === 504) {
        getMessagesWhatsapp(phone);
      }

      dispatch(slice.actions.hasError(error));
    }
  };
}





// CHATS EM ATENDIMENTO ----------------------------------------------------------------------

export function getChatsAtendimento(clienteId, usuarioId, setorId, limit = 100, isStartLoading) {

  return async (dispatch) => {
    if (isStartLoading) {
      dispatch(slice.actions.startLoadingAtendendo());
    }
    try {

      const response = await v2_actionListaByStatus(clienteId, usuarioId, "Atendendo", setorId, 100);
      dispatch(slice.actions.getChatsAtendimentoSuccess(response.data.data.chats));
      //dispatch(slice.actions.setCountsListaChats(response.data.data.counts));
    } catch (error) {
      dispatch(slice.actions.stopLoadingAtendendo());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCountsChats(clienteId, usuarioId, setorId) {
  return async (dispatch) => {
    try {
      // let querys = `?setor_id=${setorId}`	
      // const response = await v2_actionCountChats(clienteId, usuarioId, querys);
      // dispatch(slice.actions.setCountsListaChats(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// CHATS EM ATENDIMENTO ----------------------------------------------------------------------

export function getChatsPendente(clienteId, usuarioId, setorId, limit = 100, isStartLoading) {

  return async (dispatch) => {
    if (isStartLoading) {
      dispatch(slice.actions.startLoadingPendente());
    }
    try {

      const response = await v2_actionListaByStatus(clienteId, usuarioId, "Pendente", setorId, limit);
      if (response.data) {
        dispatch(slice.actions.getChatsPendenteSuccess(response.data.data.chats));
        dispatch(slice.actions.setCountsListaChats(response.data.data.counts));
      }
    } catch (error) {
      dispatch(slice.actions.stopLoadingPendente());
      dispatch(slice.actions.hasError(error));
    }
  };
}

// CHATS GERAL ----------------------------------------------------------------------

export function getChatsGeral(clienteId, usuarioId, setorId, limit, isStartLoading) {
  return async (dispatch) => {
    if (isStartLoading) {
      dispatch(slice.actions.startLoadingGeral());
    }
    try {
      const response = await v2_actionListaByStatus(clienteId, usuarioId, "Geral", setorId, limit);
      dispatch(slice.actions.getChatsGeralSuccess(response.data.data.chats));
      dispatch(slice.actions.setCountsListaChats(response.data.data.counts));

    } catch (error) {
      dispatch(slice.actions.stopLoadingGeral());
      dispatch(slice.actions.hasError(error));
    }
  };
}

// CHATS FINALIZADOS ----------------------------------------------------------------------
export function getChatsFinalizados(clienteId, usuarioId, setorId, limit = 100, isStartLoading) {

  return async (dispatch) => {
    if (isStartLoading) {
      dispatch(slice.actions.startLoadingFinalizados());
    }
    try {
      const response = await v2_actionListaByStatus(clienteId, usuarioId, "Finalizado", setorId, limit);
      dispatch(slice.actions.getChatsFinalizadosSuccess(response.data.data.chats));
      dispatch(slice.actions.setCountsListaChats(response.data.data.counts));
    } catch (error) {
      dispatch(slice.actions.stopLoadingFinalizados());
      dispatch(slice.actions.hasError(error));
    }
  };
}


// LISTA DE FUNISBY CLIENTE ID ----------------------------------------------------------------------

export function getListaFunil(clienteId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getListaFunilByChatId(clienteId);
      dispatch(slice.actions.getListaFunilSuccess(response.data));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getListaTags(querys) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await v2_actionListaTagsChats(querys);
      dispatch(slice.actions.getListaTagsSuccess(response.data.data));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}




export function setMessage(message) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.setMessageSuccess(message));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setMessageWhatsapp(message) {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.setMessageSuccess(message));

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getPesquisarChats(clienteId, value) {
  return async (dispatch) => {
    dispatch(slice.actions.setDrawerPesquisas(true));

    try {
      if (value) {
        if (value.length >= 4) {
          dispatch(slice.actions.startLoadingPesquisarChat());
          const response = await getActionPesquisarChat({ search: value, clienteId: clienteId, limit: 50 });
          dispatch(slice.actions.getPesquisarChatsSuccess(response.data.chats));
          dispatch(slice.actions.stopLoadingPesquisarChat());
        }
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.stopLoadingPesquisarChat());
    }
  };
}


// export function getMensagensWhatsappIdb(sessao, numero, page, limit) {

//   return async (dispatch) => {
//     dispatch(slice.actions.startLimparChats());
//     dispatch(slice.actions.startLoadingChat());

//     try {
//       wbWorker.onmessage = (ev) => {
//         const { body, hasMore, error, type } = ev.data;
//         if (type !== "get-messages-range") return;
//         if (error) {
//           dispatch(slice.actions.stopLoadingChat());
//           dispatch(slice.actions.getLoadMessagesWhatsappSuccess([]));
//           dispatch(slice.actions.hasError(error));
//         } else {
//           dispatch(slice.actions.getLoadMessagesWhatsappSuccess(body.sort((x, y) => x.t - y.t)));
//           dispatch(slice.actions.stopLoadingChat());
//           dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(true));
//         }
//       }

//       wbWorker.postMessage({ type: "get-messages-range", key: numero, sessao: sessao, pageSize: limit ?? 15, page: page ?? 1 });
//     } catch (error) {
//       dispatch(slice.actions.hasError(error));
//       dispatch(slice.actions.stopLoadingChat());
//     }
//   };
// }
/////>
//Busca todas menssagens do indexdb
export function getAllMenssagensWhatsappIdb(sessao, numero) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoadingChat());
    dispatch(slice.actions.startLimparChats());

    try {
      wbWorker.onmessage = async (ev) => {
        const { body, error, type, hasMore } = ev.data;

        if (type !== 'get-messages') return;

        if (error) {
          try {
            const querys = `?sessao=${sessao}&numero=${numero}&canal=whatsapp&limit=100`;
            const { data: response } = await v1_actionBuscarMensagensWhatsapp(querys);

            dispatch(slice.actions.getLoadMessagesWhatsappSuccess(response.data));
            wbWorker.postMessage({ messages: response.data, type: 'store-messages' });
            dispatch(slice.actions.stopLoadingChat());
            dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(null));
            dispatch(slice.actions.hasError(error));
          } catch (error) {
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.stopLoadingChat());
            dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(true));
          }
        } else {

          dispatch(slice.actions.getLoadMessagesWhatsappSuccess(body.sort((x, y) => x.t - y.t)));
          dispatch(slice.actions.stopLoadingChat());
          dispatch(slice.actions.setShowLoadAllMessagesWhatsapp(null));
        }
      };

      wbWorker.postMessage({ type: 'get-messages', key: numero, sessao: sessao });

    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.stopLoadingChat());
    }
  };
}










// Função para buscar análises
const fetchSentimentAnalysis = async () => {
  try {
    if (chatInfo?._id) {
      console.log('Buscando análise para o chat:', chatInfo._id);
      v2_actionGetSentimentAnalysis(chatInfo._id)
        .then(response => {
          if (response?.data?.data) {
            // Garantir que seja um array
            const analysisArray = Array.isArray(response.data.data)
              ? response.data.data
              : [response.data.data];
            setSentimentAnalysis(analysisArray);
          }
        })
        .catch(error => {
          console.error('Erro ao buscar análises:', error);
        });
    }
  } catch (error) {
    console.error('Erro ao buscar análises:', error);
  }
};




export function getSentimentAnalysis(id) {

  return async (dispatch) => {
    try {
      const response = await v2_actionGetSentimentAnalysis(id);
      dispatch(slice.actions.setSuccessSentimentAnalysis(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ALTERAR CAMPO ESPECÍFICO DO CHATINFO ----------------------------------------------------------------------
export function updateChatInfoField(field, value) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.updateChatInfoField({ field, value }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// BLOQUEAR CHAT ----------------------------------------------------------------------
export function bloquearChat({ chatId, userId, motivo }) {
  return async (dispatch) => {
    try {
      const response = await v2_actionBloquearChat(chatId, { userId, motivo });
      const chatAtualizado = response?.data?.chat;
      dispatch(slice.actions.updateChatInfoField({ field: 'bloqueado', value: true }));
      if (chatAtualizado) {
        dispatch(slice.actions.updateChatList({
          _id: chatId,
          scope: {
            bloqueado: true,
            bloqueadoEm: chatAtualizado.bloqueadoEm,
            bloqueadoPor: chatAtualizado.bloqueadoPor,
          },
        }));
      }
      return { success: true };
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao bloquear chat';
      dispatch(slice.actions.hasError(error));
      return { success: false, message };
    }
  };
}

// DESBLOQUEAR CHAT ----------------------------------------------------------------------
export function desbloquearChat({ chatId, userId }) {
  return async (dispatch) => {
    try {
      await v2_actionDesbloquearChat(chatId, { userId });
      dispatch(slice.actions.updateChatInfoField({ field: 'bloqueado', value: false }));
      dispatch(slice.actions.updateChatList({
        _id: chatId,
        scope: { bloqueado: false, bloqueadoEm: null, bloqueadoPor: null },
      }));
      return { success: true };
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao desbloquear chat';
      dispatch(slice.actions.hasError(error));
      return { success: false, message };
    }
  };
}

// SILENCIAR / REATIVAR BOT --------------------------------------------------------------
export function toggleBotSilence({ chatId, silence, userId }) {
  return async (dispatch) => {
    try {
      const response = await v2_actionToggleBotSilence(chatId, { silence, userId });
      const chatAtualizado = response?.data?.chat;
      dispatch(slice.actions.updateChatInfoField({ field: 'botSilence', value: silence }));
      dispatch(slice.actions.updateChatList({
        _id: chatId,
        scope: {
          botSilence: silence,
          botSilenceEm: chatAtualizado?.botSilenceEm || null,
          botSilencePor: chatAtualizado?.botSilencePor || null,
        },
      }));
      return { success: true };
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao alternar silêncio do bot';
      dispatch(slice.actions.hasError(error));
      return { success: false, message };
    }
  };
}

// GRUPOS WhatsApp ------------------------------------------------------------------------
export function getChatsGrupos(clienteId, canalId) {
  return async (dispatch) => {
    if (!clienteId) return;
    dispatch(slice.actions.startLoadingChatsGrupos());
    try {
      const response = await v2_actionListGroups(clienteId, canalId);
      dispatch(slice.actions.setChatsGrupos(response?.data?.data || []));
    } catch (error) {
      dispatch(slice.actions.stopLoadingChatsGrupos());
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createGroup(payload) {
  return async (dispatch) => {
    try {
      const response = await v2_actionCreateGroup(payload);
      const data = response?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true, data };
    } catch (error) {
      const message = error?.response?.data?.message || 'Erro ao criar grupo';
      return { success: false, message };
    }
  };
}

export function getGroupDetails(chatId) {
  return async (dispatch) => {
    try {
      const response = await v2_actionGetGroup(chatId);
      const data = response?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true, data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message || 'Erro' };
    }
  };
}

export function updateGroup(chatId, payload) {
  return async (dispatch) => {
    try {
      const response = await v2_actionUpdateGroup(chatId, payload);
      const data = response?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true, data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function addGroupParticipants(chatId, waIds) {
  return async (dispatch) => {
    try {
      await v2_actionAddParticipants(chatId, waIds);
      const detail = await v2_actionGetGroup(chatId);
      const data = detail?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true, data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function removeGroupParticipant(chatId, waId) {
  return async (dispatch) => {
    try {
      await v2_actionRemoveParticipant(chatId, waId);
      const detail = await v2_actionGetGroup(chatId);
      const data = detail?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function promoteGroupAdmin(chatId, waId) {
  return async (dispatch) => {
    try {
      await v2_actionPromoteAdmin(chatId, waId);
      const detail = await v2_actionGetGroup(chatId);
      const data = detail?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function demoteGroupAdmin(chatId, waId) {
  return async (dispatch) => {
    try {
      await v2_actionDemoteAdmin(chatId, waId);
      const detail = await v2_actionGetGroup(chatId);
      const data = detail?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function leaveGroup(chatId) {
  return async (dispatch) => {
    try {
      await v2_actionLeaveGroup(chatId);
      dispatch(slice.actions.removeChatGrupo(chatId));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function getGroupInviteLink(chatId) {
  return async () => {
    try {
      const response = await v2_actionGetInviteLink(chatId);
      return { success: true, data: response?.data?.data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function revokeGroupInviteLink(chatId) {
  return async (dispatch) => {
    try {
      await v2_actionRevokeInviteLink(chatId);
      const detail = await v2_actionGetGroup(chatId);
      const data = detail?.data?.data;
      if (data) dispatch(slice.actions.upsertChatGrupo(data));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function previewGroupMessageCost(chatId, body) {
  return async (dispatch) => {
    try {
      const response = await v2_actionGroupCostPreview(chatId, body);
      const data = response?.data?.data;
      dispatch(slice.actions.setGroupCostPreview(data));
      return { success: true, data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function sendGroupMessage(chatId, payload) {
  return async () => {
    try {
      const response = await v2_actionSendGroupMessage(chatId, payload);
      return { success: true, data: response?.data?.data };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}

export function getGroupEvents(chatId, opts) {
  return async (dispatch) => {
    try {
      const response = await v2_actionListGroupEvents(chatId, opts);
      dispatch(slice.actions.setGroupEvents(response?.data?.data || []));
      return { success: true };
    } catch (error) {
      return { success: false, message: error?.response?.data?.message };
    }
  };
}




